import React, { useEffect, useState } from "react";
import { Button, Empty, Form, Collapse } from "antd";

const FormItem = Form.Item;
const Panel = Collapse.Panel;

const ErrorPage = () => {
  const [errorDetails, setErrorDetails] = useState(null)

  useEffect(() => {
    // Retrieve error details from sessionStorage
    try {
      const storedError = sessionStorage.getItem('lastNetworkError')
      if (storedError) {
        const parsedError = JSON.parse(storedError)
        setErrorDetails(parsedError)
        // Log error details to console for debugging
        console.group('🔴 Network Error Details (from Error Page)')
        console.error('Error Code:', parsedError.code)
        console.error('Error Message:', parsedError.message)
        console.error('Request URL:', parsedError.config && parsedError.config.baseURL + parsedError.config && parsedError.config.url)
        console.error('Request Method:', parsedError.config && parsedError.config.method)
        console.error('Error Details:', parsedError.errorDetails)
        console.error('Request Info:', parsedError.request)
        console.error('Timestamp:', parsedError.timestamp)
        console.groupEnd()
      }
    } catch (e) {
      // Ignore parsing errors
    }
  }, [])

  return (
    <div className="gx-app-login-wrap">

      <Empty
        image={<img src={`${process.env.PUBLIC_URL}/network-error.jpeg`} />}
        imageStyle={{
          height: '50vh',
        }}
        description={
          <span>
            Something went wrong! try later.
          </span>
        }>
        <Button type="primary" onClick={() => {
          // console.log('Retrying ...');
          window.location.href = '/dashboard'
          // return <Redirect to={'/dashboard'}/>
        }}>Retry</Button>
      </Empty>

      {errorDetails && (
        <div style={{ marginTop: 20, maxWidth: 800, margin: '20px auto' }}>
          <Collapse>
            <Panel header="Error Details (Click to expand)" key="1">
              <div style={{ textAlign: 'left' }}>
                <p><strong>Error Code:</strong> {errorDetails.code || 'N/A'}</p>
                <p><strong>Error Message:</strong> {errorDetails.message || 'N/A'}</p>
                <p><strong>Error Details:</strong> {errorDetails.errorDetails || 'N/A'}</p>
                <p><strong>Response Info:</strong> {errorDetails.response || 'N/A'}</p>
                <p><strong>Request Info:</strong> {errorDetails.request || 'N/A'}</p>
                <p><strong>Request URL:</strong> {errorDetails.config && errorDetails.config.baseURL}{errorDetails.config && errorDetails.config.url}</p>
                <p><strong>Request Method:</strong> {errorDetails.config && errorDetails.config.method && errorDetails.config.method.toUpperCase() || 'N/A'}</p>
                <p><strong>Timestamp:</strong> {errorDetails.timestamp || 'N/A'}</p>
              </div>
            </Panel>
          </Collapse>
        </div>
      )}

    </div>
  );
};

export default ErrorPage;
